<template>
  <v-select
    :items="walletsToSelect"
    v-model="selectedAddress"
    item-value="address"
    class="c-input"
    outlined
    hide-details
    @change="onWalletSelected"
  >
    <template v-slot:item="{ item }">
      <div class="flex-1 d-flex align-center justify-space-between">
        <img
          :src="
            $vuetify.theme.dark
              ? walletMap[item.type].logoDark || walletMap[item.type].logo
              : walletMap[item.type].logo
          "
          height="22px"
        />
        <div class="flex-1 ml-3">
          <div class="p-14-r" style="line-height:14px;">{{ item.label }}</div>
          <div class="p-12-r mt-1">{{ item.address }}</div>
        </div>
      </div>
    </template>
    <template v-slot:selection="{ item }">
      <div class="flex-1 d-flex align-center justify-space-between pl-2">
        <img
          :src="
            $vuetify.theme.dark
              ? walletMap[item.type].logoDark || walletMap[item.type].logo
              : walletMap[item.type].logo
          "
          height="22px"
        />
        <div class="flex-1 ml-3">
          <div class="p-16-r">{{ item.address }}</div>
        </div>
      </div>
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from "vuex";
import WALLETS from "@/common/config/wallets";
export default {
  props: ["owners"],
  computed: {
    ...mapGetters({
      walletList: "userWallets/walletList",
    }),
    walletsToSelect() {
      const existingWallets = this.walletList.result.filter(
        w => w.coin_network === "ethereum"
      );
      if (this.owners) {
        const ownersAddr = this.owners.map(o => o.address.toLowerCase());
        return existingWallets.filter(w =>
          ownersAddr.includes(w.address.toLowerCase())
        );
      }
      return existingWallets;
    },
    walletMap() {
      return WALLETS.filter(
        w => w.active && w.projects.includes("ethereum") && w.name !== "gnosis"
      ).reduce((acc, cur) => ({ ...acc, [cur.name]: cur }), {});
    },
    selectedWallet() {
      return this.walletsToSelect.find(w => w.address === this.selectedAddress);
    },
  },
  data: () => ({
    selectedAddress: null,
  }),
  methods: {
    onWalletSelected() {
      if (this.selectedWallet) {
        this.$emit("onWalletSelected", this.selectedWallet);
      }
    },
  },
};
</script>
